import { render } from "./comp-form-small.vue?vue&type=template&id=1e13067f&ts=true"
import script from "./comp-form-small.vue?vue&type=script&lang=ts"
export * from "./comp-form-small.vue?vue&type=script&lang=ts"

import "./comp-form-small.vue?vue&type=style&index=0&id=1e13067f&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__